import Career from '../container/PolicyPages/Career';

function CareerPage() {
  return <Career />;
}

export default CareerPage;
